import React from 'react/addons';

import EntryPoint from 'ofs/apps/core/entry';
import models from './models';
import initViews from './views';
import ResponsiveBreadbar from '../views/ResponsiveBreadbar';


class DepartureEntryPoint extends EntryPoint {
  renderToDocument(document) {
    const options = this.options;

    if (!options.standalone) {
      super.renderToDocument(document);
    }

    const {formOptions, formData, bookingRef, contact} = options.prestay;

    const model = new models.AppointmentModel();
    const views = initViews(formOptions);

    if (formData) {
      if (formData['etd']) {
        model.set('etd', formData['etd']);
      }

      if (formData['appointment_type'] && formData['appointment_time']) {
        model.set('selected_appointment', {
          type: formData['appointment_type'],
          time: formData['appointment_time']
        });
      } else {
        model.set('selected_appointment', {
          type: formOptions['default_appointment']['type'],
          time: formOptions['default_appointment']['time']
        });
      }

      model.set('appointments', formOptions['suggested_appointments']);
    }
    const Departure = views.Departure;
    React.withContext({flux: this.flux}, () => {
      React.render(
        <Departure model={model} contact={contact} />,
        document.getElementById('departure-form')
      );
    });

    const breadbar = document.getElementById('breadbar');
    if (breadbar) {
      React.render(<ResponsiveBreadbar bookingRef={bookingRef} currentPage='book-capture-departure' />, breadbar);
    }
  }
}

module.exports = DepartureEntryPoint;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/departure/entry.jsx
 **/